import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const AddAreaModal = ({ isOpen, onClose, onConfirm, governorate, language }) => {
  const [name, setName] = useState('');

  if (!isOpen || !governorate) return null;

  const translations = {
    en: {
      addArea: "Add Area",
      areaName: "Area Name",
      enterName: "Enter area name",
      forGovernorate: "For Governorate",
      cancel: "Cancel",
      add: "Add"
    },
    ar: {
      addArea: "إضافة منطقة",
      areaName: "اسم المنطقة",
      enterName: "أدخل اسم المنطقة",
      forGovernorate: "للمحافظة",
      cancel: "إلغاء",
      add: "إضافة"
    }
  };

  const t = translations[language];

  const handleSubmit = () => {
    if (name.trim()) {
      onConfirm(name.trim());
      setName('');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center mb-4 gap-2">
            <div className="p-2 rounded-full bg-[#62b84b]">
              <Icon 
                name="Plus" 
                size={24} 
                className="text-white" 
              />
            </div>
            <h3 className="ml-3 text-lg font-semibold text-gray-900">
              {t.addArea}
            </h3>
          </div>

          {/* Content */}
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-3">
              {t.forGovernorate}: <span className="font-medium">{governorate.name}</span>
            </p>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t.areaName}
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t.enterName}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none"
            />
          </div>

          {/* Actions */}
          <div className="flex space-x-3 gap-4">
                    <Button
              onClick={handleSubmit}
             className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
            >
              {t.add}
            </Button>
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              {t.cancel}
            </button>
    
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAreaModal;